export default __webpack_public_path__ + "static/media/franquia1.6836a23e.png";